var _caption;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-var, object-curly-spacing */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

// TODO(kevindangoor) fix these lint errors
/*eslint-disable react/sort-comp, react/jsx-indent-props, react/prop-types,
    react/jsx-closing-bracket-location
*/

var classNames = require("classnames");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;

var _require2 = require("../styles/constants.js"),
    baseUnitPx = _require2.baseUnitPx;

var Changeable = require("../mixins/changeable.jsx");
var mediaQueries = require("../styles/media-queries.js");
var Renderer = require("../renderer.jsx");
var SvgImage = require("../components/svg-image.jsx");

var _require3 = require("../gorgon/proptypes.js"),
    linterContextProps = _require3.linterContextProps,
    linterContextDefault = _require3.linterContextDefault;

var defaultBoxSize = 400;
var defaultRange = [0, 10];
var defaultBackgroundImage = {
    url: null,
    width: 0,
    height: 0
};

// NOTE(david): 2016-07-20: This widget supports the 4 alignments specified
//     below, but we want to phase out the floating alignments in the next few
//     weeks. So, we remove the float options from the editor interface.
var supportedAlignments = ["block", "float-left", "float-right", "full-width"];
var editorAlignments = ["block", "full-width"];

var DEFAULT_ALIGNMENT = "block";

var ImageWidget = React.createClass({
    displayName: "ImageWidget",

    propTypes: _extends({}, Changeable.propTypes, {
        alignment: React.PropTypes.oneOf(supportedAlignments),
        alt: React.PropTypes.string,
        apiOptions: ApiOptions.propTypes,
        // TODO(alex): Rename to something else, e.g. "image", perhaps flatten
        backgroundImage: React.PropTypes.shape({
            url: React.PropTypes.string,
            width: React.PropTypes.number,
            height: React.PropTypes.number
        }),

        box: React.PropTypes.arrayOf(React.PropTypes.number),

        caption: React.PropTypes.string,

        // TODO(alex): Convert uses of this widget's labeling functionality to
        // SvgImage wherever possible (almost certainly requires a backfill)
        labels: React.PropTypes.arrayOf(React.PropTypes.shape({
            content: React.PropTypes.string,
            coordinates: React.PropTypes.arrayOf(React.PropTypes.number),
            alignment: React.PropTypes.string
        })),

        range: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.number)),

        title: React.PropTypes.string,
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    }),

    statics: {
        styles: StyleSheet.create({
            caption: (_caption = {
                display: "inline-block",
                marginTop: baseUnitPx,
                maxWidth: 640

            }, _caption[mediaQueries.lgOrSmaller] = {
                // TODO(david): This maxWidth is not being used because
                //     it's overriden by the 512px max-width we have on
                //     paragraphs.
                maxWidth: 540
            }, _caption[mediaQueries.smOrSmaller] = {
                maxWidth: 450
            }, _caption)
        })
    },

    getDefaultProps: function getDefaultProps() {
        return {
            alignment: DEFAULT_ALIGNMENT,
            title: "",
            range: [defaultRange, defaultRange],
            box: [defaultBoxSize, defaultBoxSize],
            backgroundImage: defaultBackgroundImage,
            labels: [],
            alt: "",
            caption: "",
            linterContext: linterContextDefault
        };
    },

    render: function render() {
        var image;
        var alt;
        var apiOptions = this.props.apiOptions;


        var backgroundImage = this.props.backgroundImage;

        if (backgroundImage.url) {
            image = React.createElement(SvgImage, {
                src: backgroundImage.url,
                alt:
                /* alt text is formatted in a sr-only
                       div next to the image, so we make
                       this empty here.
                       If there is no alt text at all,
                       we don't put an alt attribute on
                       the image, so that screen readers
                       know there's something they can't
                       read there :(.
                       NOTE: React <=0.13 (maybe later)
                       has a bug where it won't ever
                       remove an attribute, so if this
                       alt node is ever defined it's
                       not removed. This is sort of
                       dangerous, but we usually re-key
                       new renderers so that they're
                       rendered from scratch anyways,
                       so this shouldn't be a problem
                       in practice right now, although
                       it will exhibit weird behaviour
                       while editing. */
                this.props.alt ? "" : undefined,
                width: backgroundImage.width,
                height: backgroundImage.height,
                preloader: apiOptions.imagePreloader,
                extraGraphie: {
                    box: this.props.box,
                    range: this.props.range,
                    labels: this.props.labels
                },
                trackInteraction: this.props.trackInteraction,
                zoomToFullSizeOnMobile: apiOptions.isMobile,
                constrainHeight: apiOptions.isMobile,
                allowFullBleed: apiOptions.isMobile
            });
        }

        if (this.props.alt) {
            alt = React.createElement(
                "span",
                { className: "perseus-sr-only" },
                React.createElement(Renderer, {
                    content: this.props.alt,
                    apiOptions: apiOptions,
                    linterContext: this.props.linterContext
                })
            );
        }

        // For mobile we combine an image's title and caption.
        if (apiOptions.isMobile) {
            var titleAndCaption;

            if (this.props.title || this.props.caption) {
                var _title = this.props.title;

                // Bold the title, and make it the first sentence of the
                // caption.
                if (_title) {
                    // We add a period to separate the title from the caption
                    // (if it exists), unless the title already ends with a
                    // punctuation symbol (whitespace ignored). Copied from
                    // webapp: https://github.com/Khan/webapp/blob/6e930637edb65696d0749ea0f7558214aee32b4e/javascript/tutorial-shared-package/components/content-description.jsx#L80
                    // TODO(charlie): Internationalize this check, and the
                    // delimiter that is being inserted.
                    if (this.props.caption && !/[.?!"']\s*$/.test(_title)) {
                        _title += ".";
                    }

                    _title = "**" + _title + "** ";
                }

                var className = classNames({
                    "perseus-image-caption": true,
                    "has-title": !!_title
                });

                // Caption is left-aligned within a container that's centered
                // below the image, with these width constraints:
                //
                // 1. Size caption to width of the image on-screen.
                // 2. ... but constrain its width to a range based on the
                //    device to optimize readability - e.g. [320px, 450px] for
                //    phones.
                // 3. ... unless the image is floated, in which case we don't
                //    want the caption to overflow the image size.
                //
                // TODO(david): If caption is only 1 line long, center-align
                //     the text.
                var alignment = this.props.alignment;
                var isImageFullWidth = alignment === "block" || alignment === "full-width";

                // This minWidth takes precedence over minWidth applied via
                // Aphrodite.
                var minWidth = isImageFullWidth ? null : "0 !important";

                titleAndCaption = React.createElement(
                    "div",
                    { className: className },
                    React.createElement(
                        "div",
                        {
                            className: css(ImageWidget.styles.caption),
                            style: {
                                minWidth: minWidth
                            }
                        },
                        React.createElement(Renderer, {
                            content: _title + this.props.caption,
                            apiOptions: apiOptions,
                            linterContext: this.props.linterContext
                        })
                    )
                );
            }

            return React.createElement(
                "div",
                { className: "perseus-image-widget" },
                image,
                alt,
                titleAndCaption
            );
        } else {
            var title;
            var caption;

            if (this.props.title) {
                title = React.createElement(
                    "div",
                    { className: "perseus-image-title" },
                    React.createElement(Renderer, {
                        content: this.props.title,
                        apiOptions: apiOptions,
                        linterContext: this.props.linterContext
                    })
                );
            }

            if (this.props.caption) {
                caption = React.createElement(
                    "div",
                    { className: "perseus-image-caption" },
                    React.createElement(Renderer, {
                        content: this.props.caption,
                        apiOptions: apiOptions,
                        linterContext: this.props.linterContext
                    })
                );
            }

            return React.createElement(
                "div",
                { className: "perseus-image-widget" },
                title,
                image,
                alt,
                caption
            );
        }
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    getUserInput: function getUserInput() {
        return null;
    },

    simpleValidate: function simpleValidate(rubric) {
        return ImageWidget.validate(this.getUserInput(), rubric);
    },

    focus: $.noop
});

_.extend(ImageWidget, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

module.exports = {
    name: "image",
    // This widget's accessibility depends on its contents: if the image has
    // has a background but no alt text, it is not accessible
    accessible: function accessible(props) {
        var bgImage = props.backgroundImage;
        return !(bgImage && bgImage.url && !props.alt);
    },
    defaultAlignment: DEFAULT_ALIGNMENT,
    supportedAlignments: editorAlignments,
    displayName: "Image",
    widget: ImageWidget,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/image.jsx
 ** module id = 114
 ** module chunks = 0 1
 **/